import { GetterTree } from "vuex";
import { StateInterface } from "../index";
import { SettingsStateInterface } from "./state";

const getters: GetterTree<SettingsStateInterface, StateInterface> = {
  fullSettings(state: SettingsStateInterface) {
    return Object.keys(state.list).reduce((obj: any, key: string) => {
      obj[key] = state.list[key];
      return obj;
    }, {});
  },
  allSettings(state: SettingsStateInterface) {
    return Object.keys(state.list).reduce((obj: any, key: string) => {
      obj[key] = state.list[key].value;
      return obj;
    }, {});
  },
  imageSettings(state: SettingsStateInterface) {
    return Object.keys(state.list)
      .filter((key) => state.list[key].type == "image")
      .reduce((obj: any, key: string) => {
        obj[key] = state.list[key];
        return obj;
      }, {});
  },
  userSettings(state: SettingsStateInterface) {
    return Object.keys(state.list)
      .filter((key) => !state.list[key].devMode)
      .filter(
        (key) =>
          state.list[key].type == "bool" ||
          state.list[key].type == "select" ||
          state.list[key].type == "int" ||
          state.list[key].type == "number" ||
          state.list[key].type == "slider" ||
          state.list[key].type == "readOnly" ||
          state.list[key].type == "text" ||
          state.list[key].type == "string" ||
          state.list[key].type == "ref"
      )
      .reduce((obj: any, key: string) => {
        const skip =
          (key == "audioEnabled" &&
            !state.list._showBtnChangeAudioEnabled.value) ||
          (key == "darkMode" && !state.list.displayingDarkModeSetting?.value) ||
          (key == "sendMessageOnFinalize" &&
            !state.list.displayingSendMessageOnFinalize?.value) ||
          (key == "showEventTypeBotCommand" &&
            !state.list.displayingShowEventTypeBotCommandSetting?.value);

        if (!skip) {
          obj[key] = state.list[key];
        }

        return obj;
      }, {});
  },
  devSettings(state: SettingsStateInterface) {
    return Object.keys(state.list)
      .filter(
        (key) =>
          state.list[key].type == "bool" ||
          state.list[key].type == "select" ||
          state.list[key].type == "int" ||
          state.list[key].type == "number" ||
          state.list[key].type == "slider" ||
          state.list[key].type == "readOnly" ||
          state.list[key].type == "text" ||
          state.list[key].type == "string" ||
          state.list[key].type == "ref"
      )
      .reduce((obj: any, key: string) => {
        obj[key] = state.list[key];
        return obj;
      }, {});
  },
  currentPage(state: SettingsStateInterface) {
    return state.currentPage;
  },
  access(state: SettingsStateInterface) {
    return state.access;
  },
};

export default getters;
